module.exports = __webpack_public_path__ + "static/lambda-5f80d27d81e1452e4cab3df0551cc153.png";